import ActionDialog from "./ActionDialog";
import { finalizeBranchRequestAPI, reviewBranchRequestAPI } from "../../../../utils/api/branchRequests";

// The confirmation dialogs of the cashier branch-change workflow that can be
// started from the request row AND from the details: approve, reject, finalize.
// One implementation, so both entry points use the same text, validation
// (rejection reason >= 5 characters, explicit acknowledgement before finalizing)
// and API calls. The server re-checks everything.

export const BRANCH_EMAIL_PURPOSE = { code: "branchChange.appNotice", label: { ar: "إشعار التطبيقات بتغيير في الفرع", en: "Notify applications of a branch change" } };

export const localized = (error, t) => new Error(t.branch.errors[error?.code] || t.email.errors?.[error?.code] || error?.message || t.action.failed);

// type: "approve" | "reject" | "finalize". `onDone(workflow)` runs after success.
export default function BranchActionDialog({ type, requestId, reference, t, onDone, onClose }) {
  const token = localStorage.getItem("auth-token");
  const b = t.branch;
  const run = async (call) => {
    let workflow;
    try {
      workflow = await call();
    } catch (error) {
      throw localized(error, t);
    }
    await onDone?.(workflow);
  };

  if (type === "approve") {
    return (
      <ActionDialog t={t} title={b.approveTitle} description={b.approveText} reason={{ label: t.action.optionalNote, required: false }} confirmLabel={t.row.confirmApproval} onClose={onClose} onConfirm={(note) => run(() => reviewBranchRequestAPI(token, requestId, { decision: "approved", note }))}>
        {reference && <p className="lud-ur-muted">{reference}</p>}
      </ActionDialog>
    );
  }
  if (type === "reject") {
    return (
      <ActionDialog t={t} title={b.rejectTitle} description={b.rejectText} reason={{ label: b.rejectReason, required: true, min: 5 }} confirmLabel={t.row.confirmRejection} danger onClose={onClose} onConfirm={(reason) => run(() => reviewBranchRequestAPI(token, requestId, { decision: "rejected", reason }))} />
    );
  }
  return <ActionDialog t={t} title={b.finalizeTitle} description={b.finalizeText} ack={b.finalizeAck} confirmLabel={t.row.confirmFinalization} onClose={onClose} onConfirm={() => run(() => finalizeBranchRequestAPI(token, requestId, {}))} />;
}
